/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

export type PersonaIdentityVerificationStatus =
  (typeof PersonaIdentityVerificationStatus)[keyof typeof PersonaIdentityVerificationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PersonaIdentityVerificationStatus = {
  INCOMPLETE: 'INCOMPLETE',
  SUCCESS: 'SUCCESS',
  FLAGGED: 'FLAGGED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
  ERROR: 'ERROR',
} as const;
